import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Modal, Space, Upload, message, Button, Input } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useAddCategoryMutation } from "../../redux/Service/api";

const AddCategory = ({ setOpenAddModal, openAddModal }) => {
  const [modalKey, setModalKey] = useState(0);

  const [nameEN, setNameEN] = useState("");
  const [nameAR, setNameAR] = useState("");

  const [file, setFile] = useState(null);

  const [addCategory, { isLoading, isError, error }] = useAddCategoryMutation();

  const handleFileChange = (fileList) => {
    if (fileList.length > 0) {
      setFile(fileList[0].originFileObj);
    } else {
      setFile(null);
    }
  };

  const handleAddOffer = async () => {
    if (!nameAR) {
      message.error("Please add the arabic name");
      return;
    }
    if (!nameEN) {
      message.error("Please add the english name");
      return;
    }
    if (!file) {
      message.error("Please upload a file");
      return;
    }
    const formData = new FormData();
    formData.append("photo", file);
    formData.append("name", nameAR);
    formData.append("name_en", nameEN);

    try {
      const res = await addCategory(formData);
      setFile(null);
      setNameAR("");
      setNameEN("");
      setModalKey((prev) => prev + 1);
      res.data.message
        ? message.info(res.data.message)
        : message.success("Category added successfully");
      setOpenAddModal(false);
    } catch (error) {
      console.error("Error adding Category:", error);
      message.error("Error adding Category. Please try again.");
    }
  };

  return (
    <Modal
      key={modalKey}
      title="Add Category"
      centered
      open={openAddModal}
      onCancel={() => setOpenAddModal(false)}
      width={500}
      footer
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
        size="large"
      >
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
          size="large"
        >
          <Row className="g-2">
            <Col className="gap-3 d-flex flex-column">
              <Input
                placeholder="name in arabic"
                value={nameAR}
                onChange={(e) => setNameAR(e.target.value)}
              />
              <Input
                placeholder="name in english"
                value={nameEN}
                onChange={(e) => setNameEN(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="g-2">
            <Col className="gap-3 d-flex flex-column col-4">
              <Upload
                customRequest={({ file, onSuccess, onError }) => {
                  try {
                    onSuccess();
                  } catch (error) {
                    console.error("Error handling file:", error);
                  }
                }}
                onChange={({ fileList }) => {
                  handleFileChange(fileList);
                }}
                listType="picture"
                maxCount={1}
              >
                <Button
                  loading={false}
                  icon={<FontAwesomeIcon icon={faDownload} />}
                >
                  Upload Image (Max: 1)
                </Button>
              </Upload>
            </Col>
          </Row>
          <Row className="g-2">
            <Button type="primary" onClick={handleAddOffer} loading={isLoading}>
              add category
            </Button>
          </Row>
        </Space>
      </Space>
    </Modal>
  );
};

export default AddCategory;
